import { buildPaginationContext } from "src/components/paginationContext.ts";
import { SubscriptionFilterProps, SubscriptionPagination } from "src/model/subscription.ts";

export const { Provider, usePaginationContext } = buildPaginationContext<
  SubscriptionPagination,
  SubscriptionFilterProps
>();
